"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var email_1 = require("../tests/email");
var hasprotocol_1 = require("../tests/hasprotocol");
var lists_1 = require("../lists");
var ip_1 = require("../tests/ip");
var url_1 = require("../tests/url");
function default_1(inputArr, options) {
  return inputArr.map(function (fragment, index) {
    var encoded = encodeURI(fragment);
    // quick validations
    // 1
    if (encoded.indexOf(".") < 1 && !hasprotocol_1.default(encoded)) return fragment;
    var urlObj = null;
    var protocol = hasprotocol_1.default(encoded) || "";
    // remove the protocol before proceeding to any other test
    if (protocol) encoded = encoded.substr(protocol.length);
    // test 1: it's a file
    if (options.files && protocol === "file:///" && encoded.split(/\/|\\/).length - 1) {
      urlObj = {
        reason: "file",
        protocol: protocol,
        raw: fragment,
        encoded: encoded
      };
    }
    // test 2: it's a URL
    if (!urlObj && options.urls && url_1.default(encoded)) {
      urlObj = {
        reason: "url",
        protocol: protocol ? protocol : typeof options.defaultProtocol === "function" ? options.defaultProtocol(fragment) : options.defaultProtocol,
        raw: fragment,
        encoded: encoded
      };
    }
    // test 3: it's an email
    if (!urlObj && options.emails && email_1.default(encoded)) {
      urlObj = {
        reason: "email",
        protocol: "mailto:",
        raw: fragment,
        encoded: encoded
      };
    }
    // test 4: it's an IP
    if (!urlObj && options.ips && ip_1.default(encoded)) {
      urlObj = {
        reason: "ip",
        protocol: protocol ? protocol : typeof options.defaultProtocol === "function" ? options.defaultProtocol(fragment) : options.defaultProtocol,
        raw: fragment,
        encoded: encoded
      };
    }
    if (!urlObj) return fragment;else {
      if ((inputArr[index - 1] === "'" || inputArr[index - 1] === '"') && ~lists_1.htmlAttrs.indexOf(inputArr[index - 2])) return fragment;
      return urlObj;
    }
  });
}
exports.default = default_1;